<template>
  <div class="form-container">
    <div class="form-left-col-container">
      <div class="form-left-col">
        <div class="form-title">{{ $t('certification.form.title') }}</div>
      </div>
    </div>
    <div class="form-right-col-container">
      <div class="form-right-col">
        <div class="form-right-col-input">
          <input @input="reset" v-model="name" maxlength="50" :placeholder="$t('homeNew.feedback.form.name')" />
        </div>
        <div class="form-right-col-input">
          <input @input="reset" v-model="email" maxlength="50" type="email" :placeholder="$t('homeNew.feedback.form.email')" />
        </div>
        <div class="form-right-col-input">
          <textarea @input="reset" v-model="purpose" maxlength="1000" rows="5" :placeholder="$t('certification.form.purpose')"></textarea>
        </div>
        <div class="form-error" v-if="error">{{ error }}</div>
        <div class="form-success" v-if="success">{{ $t('certification.form.success') }}</div>
        <div class="form-button" @click="sendForm">
          <span>{{ $t('homeNew.feedback.buttonText') }}</span>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="form-button-icon">
            <path d="M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 5L19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CertificationForm',
  data() {
    return {
      name: '',
      email: '',
      purpose: '',
      error: '',
      success: false,
    };
  },
  methods: {
    reset() {
      this.error = '';
      this.success = false;
    },
    sendForm() {
      if (!this.name || !this.email || !this.purpose) {
        this.error = this.$t('certification.form.errorFillFields');
        return;
      }
      const emailPattern = /^(?!.*\.\.)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
      if (!emailPattern.test(this.email)) {
        this.error = this.$t('certification.form.errorEmail');
        return;
      }
      fetch('https://app.35fit.com/api/form', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: this.name,
          email: this.email,
          question: this.purpose,
          source: 'certification',
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.success) {
            this.success = true;
            this.name = '';
            this.email = '';
            this.purpose = '';
            setTimeout(() => {
              this.success = false;
            }, 10000);
            return;
          }
          this.error = this.$t('certification.form.errorSend');
        })
        .catch(() => {
          this.error = this.$t('certification.form.errorSend');
        });
    },
  },
};
</script>

<style scoped>
.form-container {
  max-width: 1440px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  background-color: white;
  padding: 32px 0 48px;
  flex-direction: column;
}

@media screen and (min-width: 1024px) {
  .form-container {
    flex-direction: row;
    padding: 40px 0 80px;
  }
}

.form-left-col-container {
  flex: 1 1 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
}

@media screen and (min-width: 1024px) {
  .form-left-col-container {
    justify-content: flex-start;
    padding-left: 24px;
    margin-bottom: 0;
  }
}

.form-left-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 16px;
}

@media screen and (min-width: 1024px) {
  .form-left-col {
    align-items: flex-start;
    padding: 0;
  }
}

.form-title {
  font-size: 34px;
  line-height: 1.05;
  text-transform: uppercase;
  font-weight: 700;
  text-align: center;
}

@media screen and (min-width: 768px) {
  .form-title {
    font-size: 52px;
  }
}

@media screen and (min-width: 1024px) {
  .form-title {
    text-align: left;
    max-width: 420px;
  }
}

.form-right-col-container {
  flex: 1 1 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.form-right-col {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 24px;
  width: 100%;
  padding: 0 16px;
}

@media screen and (min-width: 768px) {
  .form-right-col {
    padding: 0 24px;
  }
}

@media screen and (min-width: 1024px) {
  .form-right-col {
    padding: 0 24px 0 0;
    align-items: flex-start;
  }
}

.form-right-col-input {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.form-right-col-input input {
  border-radius: 0;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #ccc;
  height: 52px;
  color: black;
  padding: 0 12px;
  font-size: 18px;
  letter-spacing: 1.6px;
  width: 100%;
  outline-style: none;
  max-width: none;
}

.form-right-col-input input::placeholder,
.form-right-col-input textarea::placeholder {
  font-size: 18px;
}

.form-right-col-input input:focus {
  border-bottom: 1px solid black;
}

.form-right-col-input textarea {
  border-radius: 16px;
  border: 1px solid #ccc;
  margin-top: 32px;
  background-color: transparent;
  color: black;
  padding: 12px 18px;
  line-height: 1.5;
  font-size: 18px;
  resize: none;
  appearance: none;
  transition: all 0.3s;
}

.form-right-col-input textarea:focus {
  border: 1px solid black;
  outline: none;
}

.form-success {
  width: 100%;
  font-size: 20px;
  color: #59B893;
}

.form-error {
  width: 100%;
  font-size: 20px;
  color: #FF6376;
}

.form-button {
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 6px 20px 6px 28px;
  border: 1px solid black;
  border-radius: 40px;
  margin-top: 32px;
  font-size: 20px;
  cursor: pointer;
}

@media screen and (min-width: 768px) {
  .form-button {
    font-size: 24px;
  }
}

.form-button:hover {
  border-color: black;
  background-color: black;
  color: white;
  transition: all 0.3s;
}

.form-button-icon {
  transition: fill 0.3s ease;
  color: black;
}

.form-button:hover .form-button-icon {
  color: white;
}
</style>
